import React from "react";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";

interface Props {
  nonce?: string;
  children: React.ReactNode;
}

const EmotionCacheProvider = ({
  nonce = "AJbzXffZe9LYP0tc4a78",
  children,
}: Props) => {
  const cache = createCache({ key: "contentsecuritypolicy", nonce });
  return <CacheProvider value={cache}>{children}</CacheProvider>;
};

export default EmotionCacheProvider;
